import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-others-list',
  templateUrl: './e-others-list.component.html',
  styleUrls: ['./e-others-list.component.scss'],
  standalone: false
})
export class EOthersListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
